import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ResponsiveValue } from 'store/slices/help';

export function getResponsiveValue<T>(
    matches: { [key: string]: boolean },
    value: ResponsiveValue<T>
): T | undefined {
    const responsiveValue = value as { [key: string]: T };

    if(!responsiveValue) return undefined;

    let retVal = responsiveValue.default;

    if (value && typeof value !== 'object') {
        return value;
    }

    if (matches.xs && responsiveValue.xs !== undefined) {

        retVal = responsiveValue.xs;

    } else if (matches.sm && (responsiveValue.sm !== undefined || responsiveValue.xs !== undefined)) {

        retVal = responsiveValue.sm !== undefined ?
            responsiveValue.sm :
            responsiveValue.xs;

    } else if (matches.md && (responsiveValue.md !== undefined || responsiveValue.sm !== undefined ||
        responsiveValue.xs !== undefined)) {

        retVal = responsiveValue.md !== undefined ?
            responsiveValue.md :
            responsiveValue.sm !== undefined ?
                responsiveValue.sm :
                responsiveValue.xs;

    } else if (matches.lg && (responsiveValue.lg !== undefined || responsiveValue.md !== undefined ||
        responsiveValue.sm !== undefined || responsiveValue.xs !== undefined)) {

        retVal = responsiveValue.lg !== undefined ?
            responsiveValue.lg :
            responsiveValue.md !== undefined ?
                responsiveValue.md :
                responsiveValue.sm !== undefined ?
                    responsiveValue.sm :
                    responsiveValue.xs;

    } else if ((responsiveValue.xl !== undefined || responsiveValue.lg !== undefined || responsiveValue.md !== undefined ||
        responsiveValue.sm !== undefined || responsiveValue.xs !== undefined)) {

        retVal = responsiveValue.xl !== undefined ?
            responsiveValue.xl :
            responsiveValue.lg !== undefined ?
                responsiveValue.lg :
                responsiveValue.md !== undefined ?
                    responsiveValue.md :
                    responsiveValue.sm !== undefined ?
                        responsiveValue.sm :
                        responsiveValue.xs;
    }

    return retVal;
}

export function useHelpOverlayResponsiveValues<T>(
    value: ResponsiveValue<T> | undefined
): T | undefined {
    const theme = useTheme();
    const matches = {
        xs: useMediaQuery(theme.breakpoints.down('sm')),
        sm: useMediaQuery(theme.breakpoints.down('md')),
        md: useMediaQuery(theme.breakpoints.down('lg')),
        lg: useMediaQuery(theme.breakpoints.down('xl')),
        xl: true, // xl is always true
    };

    if (value) {
        return getResponsiveValue(matches, value);
    }

    return undefined;
}
